import { ApiAgendamento } from "../services/buscarAgenda";
import { AgendaItem } from "./agendaItem.type";

export function parsePtDateTime(s: string): Date {
  const [data, hora] = s.split(" ");
  const [dd, MM, yyyy] = data.split("/").map(Number);
  const [HH, mm] = (hora ?? "00:00").split(":").map(Number);
  return new Date(yyyy, (MM ?? 1) - 1, dd, HH ?? 0, mm ?? 0, 0, 0);
}

export type StatusKey =
  | "aguardando"
  | "em-atendimento"
  | "finalizada"
  | "cancelada";

export function normalizarStatus(statusApi?: string): {
  key: StatusKey;
  label: string;
} {
  const raw = (statusApi ?? "").toLowerCase().replace(/\s+/g, "");

  if (raw === "aguardando") {
    return { key: "aguardando", label: "Aguardando" };
  }

  if (raw === "ematendimento") {
    return { key: "em-atendimento", label: "Em atendimento" };
  }

  if (raw === "finalizada" || raw === "finalizado") {
    return { key: "finalizada", label: "Finalizada" };
  }

  if (raw === "cancelada" || raw === "cancelado") {
    return { key: "cancelada", label: "Cancelada" };
  }

  return { key: "aguardando", label: statusApi || "Aguardando" };
}

export function mapearParaAgendaItem(api: ApiAgendamento): AgendaItem & {
  statusKey: StatusKey;
  statusLabel: string;
} {
  const start = parsePtDateTime(api.dataInicial);
  const end = api.dateFinal ? parsePtDateTime(api.dateFinal) : undefined;

  const { key: statusKey, label: statusLabel } = normalizarStatus(api.status);

  return {
    id: api.id,
    nome: api.pessoa?.nome ?? "",
    cpf: api.pessoa?.cpf ?? "",
    telefone:
      api.pessoa?.telefoneCelular || "",
    data: start,
    dia: start.getDate(),
    horaInicio: start.toTimeString().slice(0, 5),
    horaFim: end ? end.toTimeString().slice(0, 5) : undefined,

    status: statusLabel.toLowerCase() as any,

    statusKey,
    statusLabel,
  };
}
